import { useMantineTheme } from '@mantine/core';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import {
  CartesianGrid,
  Dot,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { useAnalyticsCustomerCreationRate } from '@portals/api/partners';

import { AnalyticsWidgetWrapper } from './components/AnalyticsWidgetWrapper';

export function CustomersCreationWidget() {
  const theme = useMantineTheme();

  const analyticsCustomerCreationRate = useAnalyticsCustomerCreationRate();

  const chartData = useMemo(() => {
    if (!analyticsCustomerCreationRate.data) return [];

    return analyticsCustomerCreationRate.data?.data?.map((customer) => ({
      timestamp: customer.date,
      customers: customer.count,
    }));
  }, [analyticsCustomerCreationRate.data]);

  return (
    <AnalyticsWidgetWrapper widgetTitle="Customers count over time">
      <ResponsiveContainer width="100%" minHeight={290}>
        <LineChart
          data={chartData}
          margin={{ left: -35, right: 0, bottom: 10, top: 10 }}
          height={290}
        >
          <CartesianGrid stroke={theme.colors.gray[2]} strokeDasharray="3 3" />

          <XAxis
            dataKey="timestamp"
            tickFormatter={(value) => dayjs(value).format('MM/DD/YY')}
            tickMargin={10}
            tickSize={5}
            tickLine={{
              strokeWidth: 1,
              stroke: theme.colors.gray[2],
            }}
            axisLine={{
              strokeWidth: 1,
              stroke: theme.colors.gray[2],
            }}
            minTickGap={150}
          />

          <YAxis
            dataKey="customers"
            type="number"
            allowDataOverflow
            allowDecimals={false}
            tickLine={{
              strokeWidth: 1,
              stroke: theme.colors.gray[2],
            }}
            tick={{
              fill: theme.colors.gray[4],
              fontSize: theme.fontSizes.xs,
            }}
            axisLine={{
              strokeWidth: 1,
              stroke: theme.colors.gray[2],
            }}
          />

          <Tooltip />

          <Line
            isAnimationActive={false}
            dataKey="customers"
            strokeWidth={2}
            dot={false}
            stroke={theme.colors.indigo_accent[4]}
            type="monotone"
            activeDot={(props) => (
              <Dot
                {...props}
                fill={theme.colors.indigo_accent[4]}
                r={6}
                stroke={theme.fn.themeColor(theme.white)}
                strokeWidth={0}
              />
            )}
          />
        </LineChart>
      </ResponsiveContainer>
    </AnalyticsWidgetWrapper>
  );
}
